import React, { useEffect } from "react";
import { Label } from "reactstrap";
import './CriteriaText.css';

const CriteriaText = ({ account, session, setAnswerFactor, currentAnswer, data, setSubPageInComplete }) => {
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        });
    };

    const factorKey = data?.factor_id;
    const value = factorKey && typeof currentAnswer?.[factorKey] === 'string' ? currentAnswer[factorKey] : '';

    useEffect(() => {
        setSubPageInComplete(false);
        // if (!value || value.trim() === '') {
        //     setSubPageInComplete(true);
        // } else {
        //     setSubPageInComplete(false);
        // }
    }, [value])

    const handleInputChange = (e) => {
        const newText = e.target.value;
        if (!factorKey) return;

        setAnswerFactor(prev => ({
            ...prev,
            [factorKey]: newText
        }));
    };

    return (
        <div className="criteria-text h-100">
            <div className="label-row">
                <div>
                    <Label className="label-title">AGENT NAME:</Label>
                    <Label>{account?.Name}</Label>
                </div>
                <div>
                    <Label className="label-title">DATE:</Label>
                    <Label>{formatDate(session?.SessionDate)?.toUpperCase()}</Label>
                </div>
            </div>

            <div className="label-row">
                <div className="d-flex">
                    <Label className="label-title">CLIENT NAME:</Label>
                    <Label>
                        {currentAnswer?.clients
                            ? currentAnswer.clients.map(c => c.name).join(', ')
                            : ''}
                    </Label>
                </div>
            </div>

            <textarea
                className="form-control textarea-expand"
                value={value}
                onChange={handleInputChange}
                placeholder="Comment.."
            />
        </div>
    );
};

export default CriteriaText;
